import { ZoomMinus } from "./assets/ZoomMinus";
import { ZoomPlus } from "./assets/ZoomPlus";
import s from "./ReportZoomControl.module.scss";
interface IProps {
  scale: number;
  setScale: (value: React.SetStateAction<number>) => void;
}
const MIN_SCALE = 0.25;
const MAX_SCALE = 1.5;
const STEP = 0.25;
export const ReportZoomControl = ({ scale, setScale }: IProps) => {
  const handleZoomIn = () => {
    setScale((prev) => Math.min(prev + STEP, MAX_SCALE));
  };

  const handleZoomOut = () => {
    setScale((prev) => Math.max(prev - STEP, MIN_SCALE));
  };

  return (
    <div className={s.container}>
      <div onClick={handleZoomOut} className={s.controlButton}>
        <ZoomMinus />
      </div>
      <span className={s.scale}>{Math.round(scale * 100)}%</span>
      <div onClick={handleZoomIn} className={s.controlButton}>
        <ZoomPlus />
      </div>
    </div>
  );
};
